import React, { Fragment } from "react";
import moment from "moment";

const COLUMN_COUNT = 7;

const GATEWAY_504_PREFIX = "504 Gateway Time-out";

/** Returns display text or null if empty. Long 504 HTML/stack traces are reduced to one line. */
function formatAwsMoveErrorMessage(raw) {
  if (raw == null || raw === "") return null;
  const s = String(raw).trim();
  if (!s) return null;
  if (s.startsWith(GATEWAY_504_PREFIX)) {
    return "504 Gateway Time-out";
  }
  return s;
}

function OrderSearchResults({
  orders,
  currentOrders,
  handleUpdateClick,
  handlePageChange,
  getPageNumbers,
  currentPage,
  totalPages,
  startResult,
  endResult,
  totalOrders,
}) {
  return (
    <>
      {orders?.length > 0 && (
        <div className="section-card">
          <div className="results-header">
            <h2 className="section-title">Order Search Results</h2>
            <p className="results-message">
              Orders which are stuck due to address issue, please fill in
              missing details.
            </p>
          </div>

          <div className="table-container">
            <div className="table-wrapper">
              <table className="results-table">
                <thead>
                  <tr>
                    <th>Company Number</th>
                    <th>App Name</th>
                    <th>Order Number</th>
                    <th>Customer Order Number</th>
                    <th>Order Created On</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentOrders.map((order, index) => {
                    const errorDisplay = formatAwsMoveErrorMessage(
                      order.orderAwsMoveErrorMsg,
                    );
                    return (
                      <Fragment
                        key={order.orderEntryId ?? order.orderNumber ?? `row-${index}`}
                      >
                        <tr>
                          <td>{order.companyNumber}</td>
                          <td>{order.createdBy}</td>
                          <td>{order.orderNumber}</td>
                          <td>{order.customerOrderNumber}</td>
                          <td>{moment(order.createdOn).format("MM/DD/YYYY HH:mm")}</td>
                          <td>{order.status}</td>
                          <td>
                            <button
                              onClick={() => handleUpdateClick(order)}
                              className="update-button"
                            >
                              Update
                            </button>
                          </td>
                        </tr>
                        {errorDisplay ? (
                          <tr className="results-table-error-row">
                            <td
                              colSpan={COLUMN_COUNT}
                              className="results-table-error-cell"
                            >
                              <span className="results-table-error-label">
                                Error:
                              </span>
                              {errorDisplay}
                            </td>
                          </tr>
                        ) : null}
                      </Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="pagination">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-button"
            >
              <svg
                className="pagination-chevron"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M10 12L6 8L10 4"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Previous
            </button>

            <div className="pagination-numbers">
              {getPageNumbers().map((pageNum, index) => {
                if (pageNum === "...") {
                  return (
                    <span
                      key={`ellipsis-${index}`}
                      className="pagination-ellipsis"
                    >
                      ...
                    </span>
                  );
                }
                return (
                  <button
                    key={pageNum}
                    onClick={() => handlePageChange(pageNum)}
                    className={`pagination-number ${currentPage === pageNum ? "active" : ""}`}
                  >
                    {pageNum}
                  </button>
                );
              })}
            </div>

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="pagination-button"
            >
              Next
              <svg
                className="pagination-chevron"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M6 4L10 8L6 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            <span className="pagination-info">
              Showing {startResult}-{endResult} of {totalOrders} results
            </span>
          </div>
        </div>
      )}
    </>
  );
}

export default OrderSearchResults;
